import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Modifications as ModificationsType } from '@src/types/graphql-types'
import ModificationDropDownBase from './ModificationDropDownBase'
import FeasibilityMessage from './FeasibilityMessage'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'
import { splitMessages } from '../../utils'
import useTubeValidation from '../../useTubeValidation'
import useFormikHelper from '../../useFormikHelper'
import { insertAsteriskBetweenCharacters } from '../../ProductsConfiguration'
import { ModificationTypes } from '../../enum'
interface FiveAndThreeModificationsProps {
  disabled: boolean
  fiveModData?: ModificationsType
  threeModData?: ModificationsType
}

const FiveAndThreeModifications: React.FC<FiveAndThreeModificationsProps> = ({
  disabled,
  fiveModData,
  threeModData,
}) => {
  const formik = useFormikHelper()
  const { validationAPI } = useTubeValidation()

  const onFiveModChange = (value: string) => {
    formik.setOligoFieldValue(ModificationTypes.FiveMod, value, false)
    let sequenceString: string = ''
    if (
      formik.selectedOligoValues.sequence &&
      formik.selectedOligoValues.insertAsterisk
    ) {
      sequenceString = insertAsteriskBetweenCharacters(
        formik.selectedOligoValues.sequence,
        !!value,
        !!formik.selectedOligoValues.threeMod
      )
      formik.setFieldTouched('sequence', true, false)
      formik.setOligoFieldValue('sequence', sequenceString, true)
    }
    validationAPI({ ...formik.validationFields, fiveMod: value })
  }
  const onThreeModChange = (value: string) => {
    formik.setOligoFieldValue(ModificationTypes.ThreeMod, value, false)
    let sequenceString: string = ''
    if (
      formik.selectedOligoValues.sequence &&
      formik.selectedOligoValues.insertAsterisk
    ) {
      sequenceString = insertAsteriskBetweenCharacters(
        formik.selectedOligoValues.sequence,
        !!formik.selectedOligoValues.fiveMod,
        !!value
      )
      formik.setFieldTouched('sequence', true, false)
      formik.setOligoFieldValue('sequence', sequenceString, true)
    }
    validationAPI({
      ...formik.validationFields,
      threeMod: value,
    })
  }
  const onFiveModCategoryChange = (value: string) => {
    formik.setOligoFieldValue('fiveModCategory', value, false)
  }
  const onThreeModCategoryChange = (value: string) => {
    formik.setOligoFieldValue('threeModCategory', value, false)
  }
  const fiveModErrorList =
    (formik.errors?.fiveMod && splitMessages(formik.errors.fiveMod)) || []
  const threeModErrorList =
    (formik.errors?.threeMod && splitMessages(formik.errors.threeMod)) || []

  return (
    <>
      <ModificationDropDownBase
        disabled={disabled}
        title={
          <FormattedMessage
            id="_PC_SPEC_5MOD"
            defaultMessage="5' Modifications"
          />
        }
        description={
          <FormattedMessage
            id="CONF_FIVE_MODIFICATIONS_MESSAGE"
            defaultMessage="Please select 5’ modification from the options below. You can clear input to remove 5’ modification."
          />
        }
        categoryModifications={fiveModData?.category || []}
        onChange={onFiveModChange}
        value={formik.selectedOligoValues.fiveMod}
        onCategoryChange={onFiveModCategoryChange}
        categoryValue={formik.selectedOligoValues.fiveModCategory}
        enabledModifications={
          formik.selectedOligoValues.enabledFiveModifications
        }
      />
      {fiveModErrorList.length > 0 && (
        <ValidationErrors errors={fiveModErrorList} configuratorsRedesign />
      )}
      <ModificationDropDownBase
        disabled={disabled}
        title={
          <FormattedMessage
            id="_PC_SPEC_3MOD"
            defaultMessage="3' Modifications"
          />
        }
        description={
          <FormattedMessage
            id="CONF_THREE_MODIFICATIONS_MESSAGE"
            defaultMessage="Please select 3’ modification from the options below. You can clear input to remove 3’ modification."
          />
        }
        categoryModifications={threeModData?.category || []}
        onChange={onThreeModChange}
        value={formik.selectedOligoValues.threeMod}
        onCategoryChange={onThreeModCategoryChange}
        categoryValue={formik.selectedOligoValues.threeModCategory}
        enabledModifications={
          formik.selectedOligoValues.enabledThreeModifications
        }
      />
      {threeModErrorList.length > 0 && (
        <ValidationErrors errors={threeModErrorList} configuratorsRedesign />
      )}
      <FeasibilityMessage />
    </>
  )
}

export default FiveAndThreeModifications
